<template>
	<div>
		<div class="bg-white pl-4 pr-4" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
			<div style="width: 100%;height: 70px;align-items: center;" class="d-flex"><div class="ml-2">公海设置</div></div>
			<div>
				<el-table :data="bom" border style="width: 100%" size="mini">
					<el-table-column prop="id" label="序号" align="center" width="80"></el-table-column>
					<el-table-column label="公司状态" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.gszt" clearable placeholder="请选择" size="mini" style="width: 90%;">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column align="center" label="N天不更新线索">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.gxxs" label="描述文字" size="mini"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column align="center" label="提前X天预警">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.tqyj" label="描述文字" size="mini"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column align="center" width="80">
						<template slot="header" slot-scope="scope">
							<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
						</template>
						<template slot-scope="scope">
							<el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100; justify-content: center;">
			<div>
				<el-button type="primary" @click="onSubmi" size="mini">保存提交</el-button>
			</div>
		</el-footer>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	data() {
		return {
			bom: [],
			options: [
				{
					value: 0,
					label: '待开发'
				},
				{
					value: 1,
					label: '潜在客户'
				},
				{
					value: 2,
					label: '过期客户'
				},
				{
					value: 3,
					label: '问题客户'
				},
				{
					value: 4,
					label: '已成交'
				}
			]
		};
	},
	created() {
		this.gets()
	},
	methods: {
		gets(){
			this.axios.get('/admin/khgh/list', { token: true }).then(res => {
				this.bom = res.data.data;
			});
		},
		pustyl() {
			let e = {
				gszt:'',
				gxxs:0,
				tqyj:0
			};
			this.axios.post('/admin/khgh',e, { token: true }).then(res => {
				this.gets()
			});
		},
		onSubmi(){
			this.axios.post('/admin/khgh/list',this.bom, { token: true }).then(res => {
			});
		}
	}
};
</script>

<style></style>
